namespace Indexes {
    export class User
    implements StaticIndexDefinition {

        name = "UserAll";
        maps = [
            "from u in docs.Users select new { u.username, u.firstName, u.lastName }"
        ];
    }
}